import * as React from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import { Site } from '@envato/foundation-types'

import { getCurrentSiteDomain } from '../../../common/utils/sites'

import * as styles from './breadcrumb.module.css'

const Separator = () => <span className={styles.separator}>/</span>

export interface IMenu {
  name: string
  path?: string
}

interface IProps {
  menus: IMenu[]
  currentSite: Site
}

const BreadCrumbs = ({ menus, currentSite }: IProps) => {
  const links = menus.map((link, index) => {
    const isLastElement = index === menus.length - 1
    return (
      <React.Fragment key={index}>
        <li className={styles.list}>
          {isLastElement ? (
            <span className="name">{link.name}</span>
          ) : (
            <Link to={link.path || '#'} className={styles.link}>
              <span className="name">{link.name}</span>
            </Link>
          )}
        </li>
        {index < menus.length - 1 && <Separator />}
      </React.Fragment>
    )
  })

  const script = [
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          ${menus.map((link, index) => {
            const baseUrl = `https://${getCurrentSiteDomain(currentSite)}`
            const linkPath = link.path ? `${baseUrl}${link.path}` : baseUrl
            return `{
              "@type": "ListItem",
              "position": ${index + 1},
              "name": "${link.name}",
              "item": "${linkPath}"
            }`
          })}
        ]
      }`
    }
  ]

  return (
    <>
      <Helmet script={script} />
      <ol className={styles.root}>{links}</ol>
    </>
  )
}

export default BreadCrumbs
